import styled from 'styled-components'

import { colors } from '../../constants/colors'
import { POSITION } from '../../constants/enums'

interface TypographyProps {
  $color?: string
  $weight?: number
  $align?: 'left' | 'center' | 'right'
  $hasIcon?: boolean
  $iconPosition?: 'left' | 'right'
}

export const TypographyContainer = styled.div<TypographyProps>`
  color: ${({ $color }) => $color || colors.textPrimary};
  font-weight: ${({ $weight }) => $weight || 400};
  text-align: ${({ $align }) => $align || 'left'};
  display: flex;
  align-items: center;
  gap: ${({ $hasIcon }) => ($hasIcon ? '8px' : '0')};
  flex-direction: ${({ $iconPosition }) =>
    $iconPosition === POSITION.RIGHT ? 'row-reverse' : 'row'};

  &.h1 {
    font-size: 32px;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 24px;
      line-height: 32px;
    }
  }

  &.h2 {
    font-size: 24px;
    line-height: 32px;

    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 28px;
    }
  }

  &.h3 {
    font-size: 20px;
    line-height: 28px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 26px;
    }
  }

  &.body-large {
    font-size: 18px;
    line-height: 26px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &.body {
    font-size: 16px;
    line-height: 24px;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 22px;
    }
  }

  &.body-small {
    font-size: 14px;
    line-height: 20px;

    @media (max-width: 768px) {
      font-size: 12px;
      line-height: 18px;
    }
  }

  &.caption {
    font-size: 12px;
    line-height: 16px;

    @media (max-width: 768px) {
      font-size: 12px;
      line-height: 16px;
    }
  }
`
